import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslationService } from '../../Services/translation.service';
import { Language } from '../../Types/language.type';

@Component({
  selector: 'av-language-dropdown',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule],
  templateUrl: './av-language-dropdown.component.html',
  styleUrls: ['./av-language-dropdown.component.scss'],
})
export class AvLanguageDropdownComponent {
  private readonly translationService = inject(TranslationService);

  readonly languages = this.translationService.availableLanguages;
  readonly currentLangCode = this.translationService.currentLanguage;

  readonly currentLangLabel = computed(() => {
    const current = this.languages.find((l) => l.code === this.currentLangCode());
    return current ? current.label : 'English';
  });

  selectLanguage(lang: Language): void {
    this.translationService.setLanguage(lang);
  }
}
